import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { PageHeaderComponent } from '@mri-platform/shared/core-ui';

@Component({
  template: `
    <mri-shared-page-header pageName="Unexpected Error"></mri-shared-page-header>
    <p class="mri-heading mri-heading--3 mri-ml-medium">
      Sorry there was a unexpected problem. Please try and refresh the browser
    </p>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageHeaderComponent],
  standalone: true
})
export class UnhandledErrorPageComponent {
  @HostBinding('attr.data-testid') testId = 'UnhandledErrorPageComponent';
}
